export default __webpack_public_path__ + "static/media/bidikkampus.e5301155.png";